import * as types from '../../actionTypes'

export const setSelectedFile = file => ({
  type: types.PACING_FILE_SELECTED,
  file,
})
export const setIsSubmitting = () => ({
  type: types.PACING_FILE_SUBMITTING,
})

export const setPacingSuccess = data => ({
  type: types.PACING_FILE_SUCCEEDED,
  data,
})

export const setPacingError = (errorMessage, file) => ({
  type: types.PACING_FILE_ERROR,
  error: errorMessage,
})



// WEBPACK FOOTER //
// ./src/redux/css-admin/pacing/actions.js